import 'css-chunksrc/client/scenes/moveDocument/styles.scss';export default {
  "main": "_main_1139k_1",
  "body": "_body_1139k_8",
  "buttons": "_buttons_1139k_13"
};